import { ToggleButton, ToggleButtonGroup } from '@mui/material';

type ColumnTypeOption = {
  value: 'keyMetrics' | 'salesContributionMetrics';
  label: string;
};

const columnTypeOptions = [
  {
    value: 'keyMetrics',
    label: 'Key Metrics',
  },
  {
    value: 'salesContributionMetrics',
    label: 'Sales Contribution Metrics',
  },
] as const satisfies readonly ColumnTypeOption[];

export type ColumnTypeValue = ColumnTypeOption['value'];

type ColumnTypeSelectProps = {
  value: ColumnTypeValue;
  onChange: (value: ColumnTypeValue) => void;
};

export const ColumnTypeSelect = (props: ColumnTypeSelectProps) => {
  return (
    <ToggleButtonGroup
      exclusive
      value={props.value}
      onChange={(_e, value: ColumnTypeValue | null) =>
        value && props.onChange(value)
      }
    >
      {columnTypeOptions.map(option => (
        <ToggleButton value={option.value} key={option.value}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
